/* prettier-ignore */

import { Component, EventEmitter, input, InputSignal, Output, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import SwiperCore, { Autoplay, EffectFade, Pagination } from "swiper";
import { CommonModule } from '@angular/common';

SwiperCore.use([EffectFade, Autoplay, Pagination]);

@Component({
  selector: "register-action-buttons-standalone",
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule,
  ],
  templateUrl: "./action-buttons.component.html",
  styleUrls: ["./action-buttons.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class RegisterStandaloneActionButtonsComponent {
    @Output() public actionButtonsEmiter: EventEmitter<any> = new EventEmitter<any>();
    public isFirstSlide: InputSignal<boolean> = input<boolean>(false);
    public isLastSlide: InputSignal<boolean> = input<boolean>(false);
    public sendButtonDisabled: InputSignal<boolean> = input<boolean>(false);

    nextStep(){
        this.actionButtonsEmiter.emit('next')
    }

    goBack(){
        this.actionButtonsEmiter.emit('back')
    }

}